import React from 'react';
import Card from '../../../muiComponents/Card';
import {
    LinearProgress,
    Table,
    TableBody,
    TableContainer,
} from '@mui/material';
import TableHeader from '../../../Table/TableHeader';
import useTranslate from '../../../customHooks/useTranslate';
import type { ITableHeaderColumn } from '../../../types/lists/listTypes';

interface TableStructureProps<T> {
    onScroll: (e: React.UIEvent<HTMLDivElement, UIEvent>) => void;
    columns: ITableHeaderColumn[];
    sortedBy: string;
    sortDir: string;
    sortByField: (field: string) => void;
    isLoading: boolean;
    items: T[];
    rowComponent: React.FC<{ item: T }>;
}

const TableStructure = <T,>(props: TableStructureProps<T>) => {
    const {
        onScroll,
        columns,
        sortedBy,
        sortDir,
        sortByField,
        isLoading,
        items,
        rowComponent: RowComponent,
    } = props;
    const translate = useTranslate();

    return (
        <Card className='flex-column flex-grow min-height-0'>
            <TableContainer
                className=' flex-grow min-height-0 overflow-y-auto overflow-x-hidden'
                onScroll={onScroll}
            >
                <Table stickyHeader size='small'>
                    <TableHeader
                        headerColumns={columns}
                        sortedBy={sortedBy}
                        sortDir={sortDir}
                        sortByField={sortByField}
                        isLoading={isLoading}
                        selectable={false}
                    />
                    <TableBody>
                        {items.map((item, index) => (
                            <RowComponent key={index} item={item} />
                        ))}
                    </TableBody>
                    {items.length === 0 && (
                        <caption className='no-results'>
                            {isLoading && <LinearProgress />}
                            {items.length === 0 &&
                                !isLoading &&
                                translate('no_results')}
                        </caption>
                    )}
                </Table>
            </TableContainer>
        </Card>
    );
};

export default TableStructure;
